import { useEffect, useState, useRef } from 'react';

export function useInView(options = { threshold: 1.0, root: null, rootMargin: '0px' }) {
    const refInView = useRef(null);
    const [isInView, setIsInView] = useState(false);
    const [intersectionRatio, setIntersectionRatio] = useState(0);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
                setIntersectionRatio(entry.intersectionRatio);
            },
            {
                threshold: options.threshold,
                root: options.root,
                rootMargin: options.rootMargin,
            }
        );

        const currentRef = refInView.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
            observer.unobserve(currentRef);
            }
        };
    }, [isInView, options.threshold, options.root, options.rootMargin]);

    return { refInView, isInView, intersectionRatio };
}
